import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Mail, Phone, ArrowRight } from 'lucide-react';
import LuxuryButton from '../ui/LuxuryButton';

const StillNeedHelpBit = ({ isMobile = false }) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="luxury-card p-6 md:p-8 text-center"
        >
            <div className="max-w-2xl mx-auto">
                {/* Icon */}
                <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ type: "spring", stiffness: 200, damping: 15 }}
                    className="w-16 h-16 rounded-full bg-gradient-to-br from-champagne to-champagne/80 flex items-center justify-center mx-auto mb-6"
                >
                    <MessageCircle className="w-8 h-8 text-white" />
                </motion.div>

                {/* Title */}
                <h2 className="font-heading text-2xl md:text-3xl font-medium text-charcoal mb-4">
                    Still have questions?
                </h2>

                {/* Description */}
                <p className="text-charcoal/60 mb-8">
                    Our certified beauty advisors are here to provide personalized guidance
                    and support for your KROMAIC ritual.
                </p>

                {/* Contact Options */}
                <div className={`grid ${isMobile ? 'grid-cols-1' : 'grid-cols-3'} gap-4 mb-8`}>
                    {[
                        {
                            icon: Mail,
                            title: "Email Support",
                            description: "24/7 response",
                            action: () => window.location.href = 'mailto:care@kromaic.com'
                        },
                        {
                            icon: MessageCircle,
                            title: "Live Chat",
                            description: "Instant help",
                            action: () => console.log('Start chat')
                        },
                        {
                            icon: Phone,
                            title: "Call Us",
                            description: "Mon-Fri, 9AM-6PM EST",
                            action: () => console.log('Call')
                        }
                    ].map((option, index) => (
                        <motion.button
                            key={option.title}
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: index * 0.1 }}
                            whileHover={{ y: -4 }}
                            onClick={option.action}
                            className="p-4 rounded-xl border border-nude hover:border-champagne transition-colors"
                        >
                            <option.icon className="w-6 h-6 text-champagne mx-auto mb-3" />
                            <h3 className="font-medium text-charcoal mb-1">{option.title}</h3>
                            <p className="text-sm text-charcoal/50">{option.description}</p>
                        </motion.button>
                    ))}
                </div>

                <LuxuryButton
                    variant="primary"
                    size={isMobile ? "medium" : "large"}
                    icon={<ArrowRight />}
                    iconPosition="right"
                    onClick={() => window.location.href = '/contact'}
                    className={isMobile ? 'w-full' : ''}
                >
                    Contact Support
                </LuxuryButton>
                {/* Additional Note */}
                <p className="text-sm text-charcoal/40 mt-6">
                    Average response time: 30 minutes • Satisfaction guarantee
                </p>
            </div>
        </motion.div>
    );
};

export default StillNeedHelpBit;